import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Form } from '@tillersystems/stardust';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Field, reduxForm } from 'redux-form';
import { translate } from 'react-i18next';

import { Input } from './elements';
import { Page } from '../../components';
// import * as Actions from '../../modules/Step/actions';
import * as NavActions from '../../services/NavigationService/actions';
import * as Actions from '../../services/DataServices/CustomerDetailsService/actions';
import * as DataActions from '../../services/DataServices/SFDataService/actions';

const validate = values => {
  const errors = {};
  if (values.installationDate) {
    let parsedInstallationDate = values.installationDate.split('-');
    let parsedToDate = new Date(
      parsedInstallationDate[0],
      parsedInstallationDate[1] - 1,
      parsedInstallationDate[2],
    );

    const dateToday = new Date();
    const todayDay = String(parseInt(dateToday.getDate(), 10) + 5);
    const todayMonth = dateToday.getMonth();
    const todayYear = dateToday.getFullYear();
    let dateToCompare = new Date(todayYear, todayMonth, todayDay);

    let today = new Date();

    let lng = navigator.language || navigator.userLanguage;
    let validationInstallationDate =
      lng === 'fr-FR'
        ? "La date souhaitée d'installation doit être au moins 5 jours après la date d'aujourd'hui"
        : 'La fecha deseada de instalación tiene que ser como mínimo previa de 5 días a la fecha de hoy.';

    if (parsedToDate <= dateToCompare || parsedToDate < today) {
      errors.installationDate = validationInstallationDate;
    }
  }
  return errors;
};

const required = value => (value ? undefined : 'Required');

const { object, func } = PropTypes;

/**
 * Delivery date
 *
 * This component is in charge of displaying
 * a the delivery page
 *
 * @return {jsx}
 */

export class Delivery extends Component {
  state = {
    stageValue: 'Page 4',
    stageNumber: 4,
  };

  /**
   * PropTypes validation
   */
  static propTypes = {
    form: object.isRequired,
    history: object.isRequired,
    customerDetails: object.isRequired,
    actions: object.isRequired,
    initialize: func.isRequired,
    t: func.isRequired,
  };

  componentDidMount() {
    const { initialize, opportunity, customerDetails, actions } = this.props;
    const { stageValue, stageNumber } = this.state;

    if (opportunity._stageValue !== null) {
      actions.opportunityNeedUpdate(opportunity.getId(), stageValue, stageNumber);
    }

    initialize({
      id: customerDetails.getId(),
      installationDate: customerDetails.getInstallationDate(),
    });
    actions.setCurrentStep(3);
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.sendBackDataToSalesforce();
  }

  handleSubmit = async () => {
    const { actions, form, history } = this.props;
    actions.customerDetailsSaved(form.Delivery.values);
    history.push('/training');
  };

  renderFormField = props => (
    <Form.Field {...props}>
      <Input
        type={props.type}
        value={props.input.value}
        onChange={props.input.onChange}
        onFocus={props.input.onFocus}
        onBlur={props.input.onBlur}
      />
    </Form.Field>
  );

  render() {
    const { t, valid } = this.props;
    return (
      <Page>
        <Page.Title>{t('deliveryPage.heading')}</Page.Title>
        <Page.Paragraph>{t('deliveryPage.catchPhrase')}</Page.Paragraph>
        <Form onSubmit={this.handleSubmit} name="form">
          <Form.Group labelsWidth="100%">
            <Field
              type="date"
              label={t('deliveryPage.content')}
              name="installationDate"
              validate={[required]}
              component={this.renderFormField}
            />
          </Form.Group>
          <Form.Group>
            <Form.Field>
              <Button big primary fluid disabled={!valid}>
                {t('deliveryPage.button')}
              </Button>
            </Form.Field>
          </Form.Group>
        </Form>
      </Page>
    );
  }
}

/**
 * Action creators does our component
 * want to receive by props
 */
const mapStateToProps = state => ({
  form: state.form,
  customerDetails: state.customerDetails,
  opportunity: state.opportunity,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      ...NavActions,
      customerDetailsSaved: Actions.customerDetailsSaved,
      sendBackDataToSalesforce: DataActions.sendBackDataToSalesforce,
      opportunityNeedUpdate: DataActions.opportunityNeedUpdate,
    },
    dispatch,
  ),
});

const DeliveryConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Delivery);

const DeliveryRF = reduxForm({
  form: 'Delivery',
  destroyOnUnmount: false,
  validate,
})(DeliveryConnect);

export default translate(['translations', 'typology'])(DeliveryRF);



// WEBPACK FOOTER //
// ./src/pages/Delivery/index.js